import {
  AppBrandLink,
  AppNavigationHeader,
  NavCollapseToggle,
  OverlayNavCloseToggle,
  ResizableAppNavigation,
  useIsLeftNavCollapseEnabled,
  useOverlayNavClose,
} from '@ms/yammer-features-app-navigation';
import { UniversalCreateButtonProvider } from '@ms/yammer-universal-create-button';
import { useCampaignCreateModal } from '@ms/yammer-web-components/dist/campaignCreateEdit/CampaignCreateModal/hooks/useCampaignCreateModal';
import { useGroupCreateModal } from '@ms/yammer-web-components/dist/groupCreateEdit/LoadableGroupCreateModal';
import NavigationCommunities from '@ms/yammer-web-components/dist/navigation/NavigationCommunities';
import { usePostCreateModal } from '@ms/yammer-web-components/dist/publisher/LoadableUniversalCreatePublisherModal';
import AutocompleteAriaHost from '@ms/yammer-web-core-ui/dist/components/AutocompleteAriaHost';
import { useIsTeamsPersonalApp } from 'hooks/selectors';
import type { FC } from 'react';
import React from 'react';

import AppSearchNavPhase1 from '../AppSearchNavPhase1';
import { UserProfileMenuButton } from '../UserProfileMenuButton';
import VivaSuiteNav from '../VivaSuiteNav';

import { useHomeLinkActionButtons } from './hooks/useHomeLinkActionButtons';

export const DefaultLeftNav: FC = () => {
  const homeLinkActionButtons = useHomeLinkActionButtons();
  const isTeamsPersonalApp = useIsTeamsPersonalApp();
  const isLeftNavCollapseEnabled = useIsLeftNavCollapseEnabled();
  const onOverlayClose = useOverlayNavClose();
  const campaignCreateModal = useCampaignCreateModal('UniversalCreateButton');

  const showCollapseToggleInHeader = isLeftNavCollapseEnabled;
  const showSuiteNav = isTeamsPersonalApp && !isLeftNavCollapseEnabled;
  const collapseToggle = showCollapseToggleInHeader ? <NavCollapseToggle /> : null;
  const suiteNav = showSuiteNav ? <VivaSuiteNav /> : null;
  const headerContextMenu = onOverlayClose ? <OverlayNavCloseToggle /> : (collapseToggle ?? suiteNav);

  const isCollapseControlInHeader = showCollapseToggleInHeader || !!onOverlayClose;

  return (
    <UniversalCreateButtonProvider
      useGroupCreateModal={useGroupCreateModal}
      campaignCreateModal={campaignCreateModal}
      usePostCreateModal={usePostCreateModal}
    >
      <ResizableAppNavigation
        communitiesNavLinksContent={<NavigationCommunities />}
        collapseToggleInHeader={isCollapseControlInHeader}
        header={
          <AppNavigationHeader
            title={<AppBrandLink />}
            contextMenu={headerContextMenu}
            searchInput={
              <AutocompleteAriaHost>
                <AppSearchNavPhase1 />
              </AutocompleteAriaHost>
            }
          />
        }
        homeLinkActionButtons={homeLinkActionButtons}
        userProfileLinkActionButtons={[<UserProfileMenuButton key="UserProfileMenuButton" />]}
      />
    </UniversalCreateButtonProvider>
  );
};
